
import Big from 'big.js'
import {TypeInt, TypeFloat, TypeChar, TypeBool, TypeString, TypeError} from './../TypeDefinition'

import CodeHelpers from './CodeHelpers.js'
import ParseCall from './ParseCall'

function ParseExpression (parser, allowCallables) {
    this.parser = parser
    this.pcode = this.parser.pcode
    this.scanner = this.parser.scanner
    this.stable = this.parser.stable
    this.SC = this.parser.config
    this.allowCallables = allowCallables === undefined || allowCallables
}

ParseExpression.prototype = {
    parse () {
        return this.parserExpBoolOr()
    },
    parserExpBoolOr () {
        let resultType
        let rightType
        let opToken
        let codeHelpers = new CodeHelpers(this.parser)

        resultType = this.parserExpBoolAnd()

        while (this.scanner.nextIs(this.SC.OR)) {
            if (!resultType.isBool()) {
                this.parser.error(this.scanner.next(), 'El lado izquierdo debe ser una expresión de tipo Logica.')
                resultType = TypeError()
            }
            opToken = this.scanner.consume()

            rightType = this.parserExpBoolAnd()

            if (codeHelpers.semanticsOpCast(resultType, rightType)) {
                if (this.parser.compile) {
                    this.pcode.or(opToken)
                }
            } else {
                this.parser.error(this.scanner.next(), 'El lado derecho debe ser una expresión de tipo Logica.')
                resultType = TypeError()
            }
        }

        return resultType
    },
    parserExpBoolAnd () {
        let resultType
        let rightType
        let opToken
        let codeHelpers = new CodeHelpers(this.parser)

        resultType = this.parserExpBoolRelBool()

        while (this.scanner.nextIs(this.SC.AND)) {
            if (!resultType.isBool()) {
                this.parser.error(this.scanner.next(), 'El lado izquierdo debe ser una expresión de tipo Logica.')
                resultType = TypeError()
            }
            opToken = this.scanner.consume()

            rightType = this.parserExpBoolRelBool()

            if (codeHelpers.semanticsOpCast(resultType, rightType)) {
                if (this.parser.compile) {
                    this.pcode.and(opToken)
                }
            } else {
                this.parser.error(this.scanner.next(), 'El lado derecho debe ser una expresión de tipo Logica.')
                resultType = TypeError()
            }
        }

        return resultType
    },
    parserExpBoolRelBool () {
        let resultType
        let rightType
        let opToken
        let codeHelpers = new CodeHelpers(this.parser)

        resultType = this.parserExpBoolNot()

        while (this.scanner.nextIsIn([this.SC.EQ, this.SC.NEQ])) {
            if (!resultType.isBool()) {
                this.parser.error(this.scanner.next(), 'El lado izquierdo debe ser una expresión de tipo Logica.')
                resultType = TypeError()
            }

            opToken = this.scanner.consume()
            rightType = this.parserExpBoolNot()

            if (codeHelpers.semanticsOpCast(resultType, rightType)) {
                if (this.parser.compile) {
                    if (opToken.code === this.SC.EQ.code) {
                        this.pcode.eq(opToken)
                    } else if (opToken.code === this.SC.NEQ.code) {
                        this.pcode.neq(opToken)
                    }
                }
            } else {
                this.parser.error(this.scanner.next(), 'El lado derecho debe ser una expresión de tipo Logica.')
                resultType = TypeError()
            }
        }

        return resultType
    },
    parserExpBoolNot () {
        let resultType
        let opToken

        if (this.scanner.nextIs(this.SC.NOT)) {
            opToken = this.scanner.consume()
            resultType = this.parserExpBoolNot()

            if (resultType.isBool()) {
                if (this.parser.compile) {
                    this.pcode.not(opToken)
                }
            } else {
                this.parser.error(this.scanner.next(), 'El operador de negación espera una expresión de tipo Logica.')
                resultType = TypeError()
            }
        } else {
            resultType = this.parserExpBoolRelNum()
        }

        return resultType
    },
    parserExpBoolRelNum () {
        let resultType
        let rightType
        let opToken
        let codeHelpers = new CodeHelpers(this.parser)

        resultType = this.parserExpSumSub()

        // Simular = y <> como operadores para Entero, Real y Caracter
        while ((this.scanner.nextIsIn([this.SC.EQ, this.SC.NEQ]) && (resultType.isNumeric() || resultType.isChar())) ||
                this.scanner.nextIsIn([this.SC.GT, this.SC.LT, this.SC.GTE, this.SC.LTE])) {
            if (!resultType.isRelational()) {
                this.parser.error(this.scanner.next(), 'El lado izquierdo debe ser una expresión de tipo Entero, Real o Caracter.')
                resultType = TypeError()
            }

            opToken = this.scanner.consume()
            rightType = this.parserExpSumSub()

            if (codeHelpers.semanticsOpCast(resultType, rightType)) {
                resultType = TypeBool()
                if (this.parser.compile) {
                    if (opToken.code === this.SC.EQ.code) {
                        this.pcode.eq(opToken)
                    } else if (opToken.code === this.SC.NEQ.code) {
                        this.pcode.neq(opToken)
                    } else if (opToken.code === this.SC.GT.code) {
                        this.pcode.gt(opToken)
                    } else if (opToken.code === this.SC.LT.code) {
                        this.pcode.lt(opToken)
                    } else if (opToken.code === this.SC.GTE.code) {
                        this.pcode.gte(opToken)
                    } else if (opToken.code === this.SC.LTE.code) {
                        this.pcode.lte(opToken)
                    }
                }
            } else {
                this.parser.error(this.scanner.next(), 'El lado derecho debe ser una expresión de tipo Entero, Real o Caracter.')
                resultType = TypeError()
            }
        }

        return resultType
    },
    parserExpSumSub () {
        let resultType
        let rightType
        let opToken
        let codeHelpers = new CodeHelpers(this.parser)

        resultType = this.parserExpMulDiv()

        while (this.scanner.nextIsIn([this.SC.SUB, this.SC.SUM])) {
            if (!resultType.isNumeric()) {
                this.parser.error(this.scanner.next(), 'El lado izquierdo debe ser una expresión de tipo Entero o Real.')
                resultType = TypeError()
            }

            opToken = this.scanner.consume()
            rightType = this.parserExpMulDiv()

            if (codeHelpers.semanticsOpCast(resultType, rightType)) {
                if (this.parser.compile) {
                    if (opToken.code === this.SC.SUB.code) {
                        this.pcode.sub(opToken)
                    } else if (opToken.code === this.SC.SUM.code) {
                        this.pcode.sum(opToken)
                    }
                }
                if (rightType.isFloat()) {
                    // Cast a Real
                    resultType = TypeFloat()
                }
            } else {
                this.parser.error(this.scanner.next(), 'El lado derecho debe ser una expresión de tipo Entero o Real.')
                resultType = TypeError()
            }
        }

        return resultType
    },
    parserExpMulDiv () {
        let resultType
        let rightType
        let opToken
        let codeHelpers = new CodeHelpers(this.parser)

        resultType = this.parserExpPow()

        while (this.scanner.nextIsIn([this.SC.MUL, this.SC.DIV])) {
            if (!resultType.isNumeric()) {
                this.parser.error(this.scanner.next(), 'El lado izquierdo debe ser una expresión de tipo Entero o Real.')
                resultType = TypeError()
            }

            opToken = this.scanner.consume()
            rightType = this.parserExpPow()

            if (codeHelpers.semanticsOpCast(resultType, rightType)) {
                if (this.parser.compile) {
                    if (opToken.code === this.SC.MUL.code) {
                        this.pcode.mul(opToken)
                    } else if (opToken.code === this.SC.DIV.code) {
                        this.pcode.div(opToken)
                    }
                }
                if (rightType.isFloat() || opToken.code === this.SC.DIV.code) {
                    // Cast a Real
                    resultType = TypeFloat()
                }
            } else {
                this.parser.error(this.scanner.next(), 'El lado derecho debe ser una expresión de tipo Entero o Real.')
                resultType = TypeError()
            }
        }

        return resultType
    },
    parserExpPow () {
        let resultType
        let rightType
        let opToken

        resultType = this.parserExpFunc()

        while (this.scanner.nextIs(this.SC.POW)) {
            if (!resultType.isNumeric()) {
                this.parser.error(this.scanner.next(), 'El lado izquierdo debe ser una expresión de tipo Entero.')
                resultType = TypeError()
            }

            opToken = this.scanner.consume()
            rightType = this.parserExpFunc()

            if (resultType.isNumeric() && rightType.isNumeric()) {
                if (this.parser.compile) {
                    this.pcode.pow(opToken)
                }
                if (rightType.isFloat()) {
                    // Cast a Real
                    resultType = TypeFloat()
                }
            } else {
                this.parser.error(this.scanner.next(), 'El lado derecho debe ser una expresión de tipo Entero.')
                resultType = TypeError()
            }
        }

        return resultType
    },
    parserExpFunc () {
        let resultType
        let resultTypeB
        let opToken

        if (this.scanner.nextIsIn([this.SC.K_ABS, this.SC.K_SQRT, this.SC.K_MOD])) {
            opToken = this.scanner.consume()

            this.parser.expect(this.SC.OPEN_PAR)

            resultType = this.parse()

            if (opToken.code === this.SC.K_MOD.code) {
                this.parser.expect(this.SC.COMMA)
                resultTypeB = this.parse()
            }

            this.parser.expect(this.SC.CLOSE_PAR)

            if ((opToken.code === this.SC.K_ABS.code || opToken.code === this.SC.K_SQRT.code) && !resultType.isNumeric()) {
                this.parser.error(this.scanner.next(), 'Las funciones RC y ABS esperan valores de tipo Entero o Real como parámetros.')
                resultType = TypeError()
            } else if (opToken.code === this.SC.K_MOD.code && (!resultType.isInt() || !resultTypeB.isInt())) {
                this.parser.error(this.scanner.next(), 'La función MOD espera argumentos de tipo Entero como parámetros.')
                resultType = TypeError()
            } else {
                if (this.parser.compile) {
                    if (opToken.code === this.SC.K_ABS.code) {
                        this.pcode.abs(opToken)
                    } else if (opToken.code === this.SC.K_SQRT.code) {
                        this.pcode.sqrt(opToken)
                    } else if (opToken.code === this.SC.K_MOD.code) {
                        this.pcode.mod(opToken)
                    }
                }
            }
        } else {
            resultType = this.parserExpFactor()
        }

        return resultType
    },
    parserExpFactor () {
        let token = this.scanner.next()
        let resultType = TypeError()

        // TODO: no estoy seguro que esto esté bien que esté acá
        if (token.code === this.SC.SUB.code) {
            this.scanner.consume()
            token = this.scanner.next()
            if (this.parser.compile) {
                this.pcode.ldcons(TypeInt(), new Big(0), token)
            }
            resultType = this.parserExpFactor()
            if (!resultType.isNumeric()) {
                this.parser.error(token, 'El signo menos debe ser seguido de una expresión numérica.')
                resultType = TypeError()
            } else {
                if (this.parser.compile) {
                    this.pcode.sub(token)
                }
            }
        } else if (token.code === this.SC.IDENT.code) {
            resultType = this.parserExpVarParamFunc()
        } else if (token.code === this.SC.OPEN_PAR.code) {
            this.scanner.consume()
            resultType = this.parse()
            this.parser.expect(this.SC.CLOSE_PAR)
        } else if (token.code === this.SC.CONS_INT.code) {
            this.scanner.consume()
            resultType = TypeInt()
            if (this.parser.compile) {
                this.pcode.ldcons(resultType, token.lexema, token)
            }
        } else if (token.code === this.SC.CONS_FLOAT.code) {
            this.scanner.consume()
            resultType = TypeFloat()
            if (this.parser.compile) {
                this.pcode.ldcons(resultType, token.lexema, token)
            }
        } else if (token.code === this.SC.CONS_STRING.code) {
            this.scanner.consume()
            if (token.lexema.length === 1) {
                resultType = TypeChar()
                if (this.parser.compile) {
                    this.pcode.ldcons(resultType, new Big(token.lexema.charCodeAt(0)), token)
                }
            } else {
                resultType = TypeString()
                if (this.parser.compile) {
                    this.pcode.ldcons(resultType, token.lexema, token)
                }
            }
        } else if (token.code === this.SC.CONS_CHAR.code) {
            this.scanner.consume()
            resultType = TypeChar()
            if (this.parser.compile) {
                this.pcode.ldcons(resultType, token.lexema, token)
            }
        } else if (token.code === this.SC.CONS_BOOL.code) {
            this.scanner.consume()
            resultType = TypeBool()
            if (this.parser.compile) {
                this.pcode.ldcons(resultType, token.lexema, token)
            }
        } else if (token.code === this.SC.NOT.code) {
            this.scanner.consume()
            resultType = this.parse()
            if (this.parser.compile) {
                if (resultType.isBool()) {
                    this.pcode.not(token)
                } else {
                    this.parser.error(token, 'Error al negar expresión lógica.')
                }
            }
        }

        return resultType
    },
    parserExpVarParamFunc () {
        let resultType
        let indexType
        let ident
        let token
        let codeHelpers = new CodeHelpers(this.parser)
        let parseCall = new ParseCall(this.parser)

        ident = this.scanner.next()
        if (this.stable.hasStorage(ident.lexema)) {
            resultType = this.stable.getStorage(ident.lexema).getType()
            this.scanner.consume()
            if (resultType.isArray()) {
                token = this.parser.expect(this.SC.INDEX_SEL_OPEN)
                if (token === false) {
                    this.parser.error(ident, 'La variable ' + ident.lexema + ' es un arreglo, se esperaba apertura de corchetes1.')
                }

                token = this.scanner.next()
                indexType = this.parse()

                if (!indexType.isInt()) {
                    this.parser.error(token, 'La expresión para acceder al arreglo debe ser de tipo entera.')
                }

                this.parser.expect(this.SC.INDEX_SEL_CLOSE)
            }
            if (this.parser.compile) {
                codeHelpers.codeVariableLoad(ident)
            }
        } else if (this.stable.hasFunction(ident.lexema)) {
            if (this.allowCallables) {
                resultType = parseCall.callableCall(true)
            } else {
                this.parser.error(ident, 'No se admiten funciones en este contexto.')
            }
        } else if (this.stable.hasMethod(ident.lexema)) {
            this.parser.error(ident, 'El sub proceso ' + ident.lexema + ' no puede ser utilizado en una expresión.')
            resultType = TypeError()
        } else {
            this.parser.error(ident, 'Identificador ' + ident.lexema + ' no definido.')
            resultType = TypeError()
        }

        return resultType
    }
}

export default ParseExpression



// WEBPACK FOOTER //
// ./src/Core/Parser/Components/ParseExpression.js